<template>
    <div class="ask">
        <span class="ask-title">
            {{ ask.title }}
        </span>
        <div class="answer-content" v-if="feedbackTypeHasAnswers">
            <answer :answer="ask.pivot" />
        </div>
        <div class="answer-content" v-if="feedbackTypeHasPendingAnswers">
            <description
                :value.sync="currentAnswer"
                :placeholder="$t('talk.form.writeAnswer')"
                :toolbar="toolbar"
                :state="state"
                :maxHeight="true"
            />
        </div>
    </div>
</template>

<script>
import { Answer } from './'

import { Description } from '@/views/components/fields'
export default {
    name: 'Ask',
    components: {
        Answer,
        Description,
    },
    props: {
        ask: Object,
        type: String,
        state: {
            required: true,
        },
        canViewForm: {
            required: true,
            type: Boolean,
        },
    },
    data() {
        return {
            toolbar: [
                'bold',
                'italic',
                'underline',
                'strike',
                { list: 'ordered' },
                { list: 'bullet' },
            ],
            currentAnswer: '',
        }
    },
    watch: {
        currentAnswer() {
            this.$emit('answerChanged', this.currentAnswer)
        },
    },
    computed: {
        feedbackTypeHasAnswers() {
            return ['requested', 'received', 'sent'].includes(this.type)
        },
        feedbackTypeHasPendingAnswers() {
            return this.type === 'pending' && this.canViewForm
        },
    },
}
</script>

<style lang="sass" scoped>
.ask
    border-bottom: 1px solid #ececec
    padding: 20px 10px
    .ask-title
        font-weight: 700
        color: #6e6e6e
        display: inline-block
        overflow-wrap: break-word
        width: 100%
    .answer-content
        padding-top: 10px
</style>
